import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import EnterAuthPage from './EnterAuthPage';
import { dataCaptureSelectors } from '../../store/dataCapture';
import { ENTER_AUTH_PAGE } from '../../utils/constants';
import { authenticateLetterCode } from '../../infrastructure/offers';

const EnterAuthSection = ({ authenticateLetterCode, getBusinessData }) => (
  <EnterAuthPage saveEnterAuthForm={authenticateLetterCode} getBusinessData={getBusinessData} />
);

EnterAuthSection.propTypes = {
  saveEnterAuthForm: PropTypes.func.isRequired
};

const actionCreators = {
  authenticateLetterCode
};

const mapStateToProps = state => ({
  getBusinessData: dataCaptureSelectors.getBusinessData(state, ENTER_AUTH_PAGE)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EnterAuthSection);
